import { ReactNode } from 'react';
import { pipe } from 'fp-ts/function';
import { withAsyncContainer } from './AsyncContainer';

export const AsyncWrapper = pipe(({ children }: { children: ReactNode }) => <>{children}</>, withAsyncContainer);
